import {
	LOGOUT,
	REHYDRATE,
	INCOMING_CALL,
	UPDATE_CALL,
	CLEAR_CALL,
	CALL_COMMAND_START,
	CALL_COMMAND_END,
	SET_CALL_MUTE,
} from "@Actions/types";

const initialState = {
	activeCall: null,
	commandInProgress: null,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case LOGOUT: {
			return { ...initialState };
		}

		case REHYDRATE: {
			return {
				...state,
				activeCall: null,
				commandInProgress: null,
			};
		}

		case INCOMING_CALL: {
			return {
				...state,
				activeCall: {
					...payload.data,
					status: payload.data?.status || "incoming",
					micMuted: Boolean(payload.data?.micMuted),
				},
			};
		}

		case UPDATE_CALL: {
			const nextCall = state.activeCall ? { ...state.activeCall, ...payload.data } : payload.data;
			const status = String(nextCall?.status || "").toLowerCase();
			if (status === "ongoing" && !nextCall.connectedAt) {
				nextCall.connectedAt = Date.now();
			}
			return {
				...state,
				activeCall: {
					...nextCall,
					micMuted: Boolean(nextCall?.micMuted),
				},
			};
		}

		case CLEAR_CALL: {
			return {
				...state,
				activeCall: null,
				commandInProgress: null,
			};
		}

		case CALL_COMMAND_START: {
			return {
				...state,
				commandInProgress: payload.data,
			};
		}

		case CALL_COMMAND_END: {
			return {
				...state,
				commandInProgress: null,
			};
		}

		case SET_CALL_MUTE: {
			if (!state.activeCall) return state;
			return {
				...state,
				activeCall: {
					...state.activeCall,
					micMuted: Boolean(payload.data),
				},
			};
		}

		default:
			return state;
	}
}
